import React from 'react';

// Public teaser for the Search tab while the dataset work lands (the live
// explorer is user-1 only at /v2lab). Shown to everyone else from the
// sidebar's Search entry.
const SearchComingSoon: React.FC = () => (
  <div className="max-w-2xl mx-auto px-6 py-16">
    <div className="bg-white rounded-2xl border border-gray-200 shadow-sm px-10 py-12 text-center">
      <span className="inline-flex items-center px-3 py-1 rounded-full text-[11px] font-semibold bg-violet-50 text-violet-700 ring-1 ring-inset ring-violet-600/20 uppercase tracking-wide mb-5">
        Coming soon
      </span>
      <h1 className="text-2xl font-bold text-gray-900 mb-3">Search the whole market</h1>
      <p className="text-sm text-gray-500 leading-relaxed mb-8">
        A people and companies search across hundreds of millions of live profiles —
        filter by title, skills, tenure, industry, headcount and more, then push
        results straight into your projects, pipelines and campaigns.
      </p>
      <div className="grid sm:grid-cols-3 gap-4 text-left">
        {[
          { h: 'People search', d: 'Titles, skills, experience, education — current or past.' },
          { h: 'Company search', d: 'Industry, headcount, founded date, technology, keywords.' },
          { h: 'Straight to work', d: 'One click from a result set to a mapped project or pipeline.' },
        ].map((f) => (
          <div key={f.h} className="rounded-xl bg-violet-500/5 px-4 py-3.5">
            <p className="text-sm font-semibold text-violet-900">{f.h}</p>
            <p className="text-xs text-gray-500 mt-1">{f.d}</p>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default SearchComingSoon;
